import Decimal from "decimal.js";
const IgnoreValue = Symbol("ignore");
const deterministicObjectStringify = (obj, path) => {
    // hash the object in a deterministic way
    if (typeof obj === "bigint") {
        return obj.toString();
    }
    else if (typeof obj === "boolean") {
        return obj ? "true" : "false";
    }
    else if (typeof obj === "number") {
        return obj.toString();
    }
    else if (typeof obj === "function") {
        throw new Error(`Cannot hash functions at path ${path}`);
    }
    else if (typeof obj === "string") {
        return `"${obj}"`;
    }
    else if (obj === IgnoreValue) {
        return "<ignore>";
    }
    else if (typeof obj === "symbol") {
        throw new Error(`Cannot hash symbols at path ${path}`);
    }
    else if (obj === null) {
        return "<null>";
    }
    else if (obj === undefined) {
        return "<undefined>";
    }
    else if (obj instanceof Date) {
        return obj.toISOString();
    }
    else if (obj instanceof Decimal) {
        return obj.toString();
    }
    else if (Array.isArray(obj)) {
        return `[${obj
            .map((x, i) => deterministicObjectStringify(x, `${path}.${i}`))
            .join(",")}]`;
    }
    else if (typeof obj === "object") {
        // We sort by key to ensure that the hash is deterministic
        const entries = Object.entries(obj).sort((a, b) => a[0].localeCompare(b[0]));
        return `{${entries
            .map(([key, value]) => `${key}:${deterministicObjectStringify(value, `${path}.${key}`)}`)
            .join(",")}}`;
    }
    throw new Error(`Cannot hash unknown type at path ${path}`);
};
export const webDeterministicHash = async (value, path) => {
    const encoder = new TextEncoder();
    const json = deterministicObjectStringify(value, path ?? "root");
    const data = encoder.encode(json);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hash = hashArray.map((b) => b.toString(36)).join(""); // convert bytes to hex string
    return hash;
};
//# sourceMappingURL=webDeterministicHash.js.map